export const InvalidCouponType = {
    invalid: 'invalid',
    expired: 'expired',
    usageLimit: 'usageLimit',
    minPurchase: 'minPurchase',
}

export const InvalidCouponMessage = {
    [InvalidCouponType.invalid] : 'Invalid coupon!',
    [InvalidCouponType.expired] : 'Coupon expired!',
    [InvalidCouponType.usageLimit] : 'Invalid coupon!',
    [InvalidCouponType.minPurchase] : 'Invalid coupon!',
}

// Picks the coupon (from an applicable-offers list) that yields the largest
// effective discount for the given price, ignoring any already-disabled/ineligible offers.
export const getBestPromoCode = (items, price) => {
    const validItems = (items || []).filter((item) => !item?.disabled);
    if (!validItems.length) return null;
    let bestItem = null;
    let bestValue = -1;
    validItems.forEach((item) => {
        let value;
        if (item?.discountType === 'amount') {
            value = parseFloat(item?.discount) || 0;
        } else {
            const pct = ((parseFloat(item?.discount) || 0) / 100) * (parseFloat(price) || 0);
            value = item?.maxDiscount > 0 ? Math.min(pct, item.maxDiscount) : pct;
        }
        if (value > bestValue) {
            bestValue = value;
            bestItem = item;
        }
    });
    return bestItem?.code || null;
}